import { db } from "@/config/firebaseConfig";

const addUserMGMDataBase = async (idSon, idFather, verified) => {
  try {
    const ref = db.ref(`MGM/${idSon}`);
    await ref.set({
      from: idFather,
      getCoins: verified,
    });
  } catch (error) {
    console.log(error);
  }
};

const updateUserMGMDataBase = async (idSon, verified) => {
  try {
    const ref = db.ref(`MGM/${idSon}`);
    await ref.update({
      getCoins: verified,
    });
  } catch (error) {
    console.log(error);
  }
};

const isMGM = async (id) => {
  
  let isMember = null;
  try {
    const ref = db.ref(`/MGM/${id}`);
    await ref.once("value", async (snapshot) => {
      isMember = await snapshot.val();
    });
  } catch (error) {
    console.log(error);
  }

  return isMember;
};

const setCoins = async (id) => {
  try {
    const ref = db.ref(`coins/${id}/total`);
    await ref.transaction((current_value) => {
      return (current_value || 0) + 1;
    });
  } catch (error) {
    console.log(error);
  }
};

const getCoins = async (id) => {
  let coins;
  try {
    const ref = db.ref(`coins/${id}`);
    await ref.once("value", (snapshot) => {
      snapshot.forEach((childsnapshot) => {
        coins = childsnapshot.val();
      });
    });
  } catch (error) {
    console.log(error);
  }
  return coins;
};

export { addUserMGMDataBase, getCoins, isMGM, setCoins, updateUserMGMDataBase };
